/* @flow */

import React from 'react';

import type { ErrorType } from '../redux/reducer/meta';
import ConnectionError from './ConnectionError';
import UnrecoverableError from './UnrecoverableError';

type Props = { error: ErrorType };

const ErrorModal = ({ error }: Props) => {
  return (
    <div className="proc proc-error-modal">
      {error.type === 'CONNECTION_ERROR' && <ConnectionError {...error.props} />}
      {error.type === 'UNRECOVERABLE_ERROR' && <UnrecoverableError />}
    </div>
  );
};

export default ErrorModal;
